import { UiOption } from '@/lib/helpers';

export type ControlActionValue = 'ignore' | 'log' | 'warn' | 'block' | 'tag' | 'mask' | 'delete';

export type ControlCategory = 'allow' | 'redact' | 'disallow';

type ControlActionCategory = { label: string; value: ControlCategory; level: number };

export const ControlActionCategories: ControlActionCategory[] = [
  { label: 'Allow', value: 'allow', level: 100 },
  { label: 'Redact', value: 'redact', level: 200 },
  { label: 'Disallow', value: 'disallow', level: 300 },
];

type ActionWithCategoryAndLevel = {
  value: string;
  category: string;
  level: number;
};

export const getActionLevel = <T extends string>(
  value: T,
  actions: ActionWithCategoryAndLevel[]
): number => {
  const action = actions.find(({ value: optValue }) => optValue === value);
  if (!action) {
    return 0;
  }

  const category = ControlActionCategories.find(({ value }) => value === action.category);

  return (category?.level || 0) + action.level;
};

export const ControlCategoryActionMapping: {
  header: string;
  actions: ControlActionValue[];
}[] = [
  {
    header: 'Allow',
    actions: ['ignore', 'log', 'warn'] as ControlActionValue[],
  },
  {
    header: 'Redact',
    actions: ['tag', 'mask', 'delete'] as ControlActionValue[],
  },
  {
    header: 'Disallow',
    actions: ['block'] as ControlActionValue[],
  },
];

export type ControlAction = {
  label: string;
  value: ControlActionValue;
  level: number;
  category: ControlCategory;
};

export const ControlActions: ControlAction[] = [
  { label: 'Ignore', value: 'ignore', category: 'allow', level: 1 },
  { label: 'Monitor', value: 'log', category: 'allow', level: 2 },
  { label: 'Warn', value: 'warn', category: 'allow', level: 3 },
  { label: 'Tag', value: 'tag', category: 'redact', level: 1 },
  { label: 'Mask', value: 'mask', category: 'redact', level: 2 },
  { label: 'Delete', value: 'delete', category: 'redact', level: 3 },
  { label: 'Block', value: 'block', category: 'disallow', level: 1 },
];

export const getControlActionLevel = (value: ControlActionValue): number => {
  return getActionLevel(value, ControlActions);
};

export const getSettingOptions = (action: ControlActionValue, comingSoon = false): UiOption => {
  const { label, value } = ControlActions.find(({ value: optValue }) => optValue === action) || {
    label: action.charAt(0).toUpperCase() + action.slice(1),
    value: action,
  };
  return {
    label,
    value,
    disabled: comingSoon,
    meta: { comingSoon },
  };
};
